export default "__VITE_ASSET__099089df__"